var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeftGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03033 10.9697C7.32322 11.2626 7.32322 11.7374 7.03033 12.0303C6.73744 12.3232 6.26256 12.3232 5.96967 12.0303L0.96967 7.03033C0.676776 6.73744 0.676776 6.26256 0.96967 5.96967L5.96967 0.96967C6.26256 0.676777 6.73744 0.676777 7.03033 0.96967C7.32322 1.26256 7.32322 1.73744 7.03033 2.03033L2.56066 6.5L7.03033 10.9697Z",
    fill: "#00E4AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftGreen);
export default __webpack_public_path__ + "static/media/chevron-left-green.fded9eefd22030fbbeb11f7b5ffaed11.svg";
export { ForwardRef as ReactComponent };